import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  manageContainer: {
    padding: 16,
    maxWidth: 1080,
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.gray[800],
    margin: ' 0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,

    [Theme.breakpoints.up('md')]: {
      padding: '24px 40px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '16px 0px',
    },
    '& h4, p': {
      fontFamily: 'inherit',
    },
    '& .flight-summary-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },

    '& .no-flights-content': {
      padding: 24,
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[3],
      },
    },

    '& .no-flights-actions': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      background: Theme.palette.gray[100],
      padding: '16px 24px',
      gap: 24,
      [Theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
  },

  backToAmendButtonContainer: {
    alignSelf: 'flex-start',
    '& .back-amend-button': {
      color: Theme.palette.primary.light,
      fontSize: Theme.typography.size[2],
      textDecoration: 'underline',
      padding: '0',
      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[3],
      },
      '& svg': {
        marginLeft: '-6px',
      },
      '&:hover': {
        background: 'none',
      },
    },
  },

  cancellationFeesDrawer: {
    width: '100%',
    [Theme.breakpoints.up('sm')]: {
      width: '390px',
    },
    [Theme.breakpoints.up('lg')]: {
      width: '640px',
    },
  },
}));

export default useStyles;
